<script setup lang="ts">
const nuxtApp = useNuxtApp()
const { activeHeadings, updateHeadings } = useScrollspy()

const items = computed(() => [
  {
    label: 'Services',
    to: '#services',
    active:
      activeHeadings.value.includes('services') &&
      !activeHeadings.value.includes('work-were-proud-of')
  },
  {
    label: 'Projects',
    to: '#work-were-proud-of',
    active: activeHeadings.value.includes('work-were-proud-of')
  },
  {
    label: 'Coverage',
    to: '#areas-i-cover',
    active:
      activeHeadings.value.includes('areas-i-cover') &&
      !activeHeadings.value.includes('work-were-proud-of')
  }
])

nuxtApp.hooks.hookOnce('page:finish', () => {
  updateHeadings(
    [
      document.querySelector('#features'),
      document.querySelector('#pricing'),
      document.querySelector('#testimonials')
    ].filter(Boolean) as Element[]
  )
})
</script>

<template>
  <UHeader>
    <template #left>
      <AppLogo class="text-primary h-10 w-auto shrink-0" />
    </template>

    <template #right>
      <UNavigationMenu
        :items="items"
        variant="link"
        class="hidden lg:block"
      />
    </template>

    <template #body>
      <UNavigationMenu
        :items="items"
        orientation="vertical"
        class="-mx-2.5"
      />
    </template>
  </UHeader>
</template>
